import './index.css';

export default {
  name: 'AscrollBox',
  props: {
    id: { type: String, default: () => (`a-scroll-box-${Math.random().toString().substring(2)}`) },
  },
  methods: {
    scroll(a) {
      a.preventDefault();
      let container = document.getElementById(this.id);
      container && (container.scrollLeft += a.deltaY);
    },
  },
  render() {
    return this.$slots.default && (
      <div class="a-scroll-box">
        <div class="a-scroll-box-main" id={this.id} on-wheel={this.scroll}>
          {this.$slots.default}
        </div>
      </div>
    );
  }
}